window.themeFormatPrice = {
  symbol: window.themeFormatPrice?.symbol ?? '',

  formatAmount(whole) {
    if (whole >= 1000) {
      const thousands = Math.floor(whole / 1000);
      const remainder = whole % 1000;
      return `${thousands} ${String(remainder).padStart(3, '0')}`;
    }

    return String(whole);
  },

  format(cents) {
    const whole = Math.round(Number(cents) / 100);
    const formattedAmount = this.formatAmount(whole);
    const symbol = this.symbol;

    return `<span class="price-formatted"><span class="price-formatted__amount">${formattedAmount}</span><span class="price-formatted__currency">${symbol}</span></span>`;
  },

  formatPlain(cents) {
    const whole = Math.round(Number(cents) / 100);
    return `${this.formatAmount(whole)} ${this.symbol}`.trim();
  },
};
